export default __webpack_public_path__ + "static/media/01_babcock.73ebd68a.png";